import React from 'react';
import './CertificateCarousel.css';

const CertificateCarousel = () => {
  const [certTranslate, setCertTranslate] = React.useState(0);
  const [isAnimating, setIsAnimating] = React.useState(false);
  const [enableTransition, setEnableTransition] = React.useState(true);
  
  // Lightbox state
  const [lightboxOpen, setLightboxOpen] = React.useState(false);
  const [lightboxImage, setLightboxImage] = React.useState('');

  const certificates = [
    {
      id: 1,
      image: '/images/carousel slider certificate/9254    9K    GLOBAL SOLAR ENERGY.jpg',
      title: 'Global Solar Energy Certificate 1'
    },
    {
      id: 2,
      image: '/images/carousel slider certificate/9255    14K    GLOBAL SOLAR ENERGY.jpg',
      title: 'Global Solar Energy Certificate 2'
    },
    {
      id: 3,
      image: '/images/carousel slider certificate/9256    45K    GLOBAL SOLAR ENERGY.jpg',
      title: 'Global Solar Energy Certificate 3'
    },
    {
      id: 4,
      image: '/images/carousel slider certificate/Adobe Scan 02 Dec 2025.jpg',
      title: 'GEDA Certificate'
    },
    {
      id: 5,
      image: '/images/carousel slider certificate/electrical contractor.jpg',
      title: 'Electrical Contractor Certificate'
    },
    {
      id: 6,
      image: '/images/carousel slider certificate/Global solar energy 9060 (1).jpg',
      title: 'Global Solar Energy ISO 9060'
    },
    {
      id: 7,
      image: '/images/carousel slider certificate/Global solar energy 50001 (1).jpg',
      title: 'Global Solar Energy ISO 50001'
    },
    {
      id: 8,
      image: '/images/carousel slider certificate/US Global solar energy ROHS (1).jpg',
      title: 'US Global Solar Energy ROHS'
    }
  ];

  // Triple certificates for seamless infinite scroll
  const duplicatedCertificates = [...certificates, ...certificates, ...certificates];
  const itemWidth = 330; // 300px width + 30px gap
  const totalOriginalWidth = certificates.length * itemWidth;

  // Open lightbox with selected image
  const openLightbox = (imageSrc) => {
    setLightboxImage(imageSrc);
    setLightboxOpen(true);
  };

  // Close lightbox
  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage('');
  };

  // Handle left arrow click
  const handleLeftClick = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setEnableTransition(true);
    
    const newTranslate = certTranslate + itemWidth;
    setCertTranslate(newTranslate);
    
    setTimeout(() => {
      if (newTranslate >= 0) {
        setEnableTransition(false);
        setCertTranslate(-totalOriginalWidth);
      }
      setIsAnimating(false);
    }, 500);
  };

  // Handle right arrow click
  const handleRightClick = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setEnableTransition(true);
    
    const newTranslate = certTranslate - itemWidth;
    setCertTranslate(newTranslate);
    
    setTimeout(() => {
      if (newTranslate <= -(totalOriginalWidth * 2)) {
        setEnableTransition(false);
        setCertTranslate(-totalOriginalWidth);
      }
      setIsAnimating(false);
    }, 500);
  };

  return (
    <>
      <div className="certificate-carousel">
        <div className="carousel-container">
          <div className="scrolling-wrapper">
            <div
              className="scrolling-track"
              style={{
                transform: `translateX(${certTranslate}px)`,
                transition: enableTransition ? 'transform 0.5s ease' : 'none'
              }}
            >
              {duplicatedCertificates.map((certificate, index) => (
                <div key={`${certificate.id}-${index}`} className="certificate-item">
                  <div className="certificate-card">
                    <div
                      className="certificate-image"
                      onClick={() => openLightbox(certificate.image)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        src={certificate.image}
                        alt={certificate.title}
                        loading="lazy"
                      />
                    </div>
                    <div className="certificate-overlay">
                      <h4>{certificate.title}</h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Navigation Arrows */}
          <div className="cert-carousel-nav">
            <button
              className="cert-nav-arrow cert-nav-left"
              onClick={handleLeftClick}
              disabled={isAnimating}
            >
              ‹
            </button>
            <button
              className="cert-nav-arrow cert-nav-right"
              onClick={handleRightClick}
              disabled={isAnimating}
            >
              ›
            </button>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div className="cert-lightbox-overlay" onClick={closeLightbox}>
          <div className="cert-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={lightboxImage} alt="Certificate" className="cert-lightbox-image" />
            <button className="cert-lightbox-close" onClick={closeLightbox}>×</button>
          </div>
        </div>
      )}
    </>
  );
};

export default CertificateCarousel;